import template from './employee_add_field.html';
import tr from '../../lib/default-translator.js';

class EmployeeCreateFieldViewModel
{
	constructor (dialog)
	{
		this.dialog = dialog;
		this.description = ko.observable();
		this.field_type = ko.observable();
		this.category = ko.observable();
		this.main_category = ko.observable();
		this.allowed_values = ko.observableArray([ko.observable('')]);
		// this.product_id = ko.observable(null);
		this.default_value = ko.observable();
		this.isExpired = ko.observable(false);
		this.employee_field_categories = ko.observableArray();
		this.employee_field_main_categories = ko.observableArray();
		this.access_roles = ko.observableArray();
		this.selectedRoles = ko.observableArray();
		this.departments = ko.observableArray();
		this.department = ko.observable();
	};

	close()
	{
		this.dialog.close();
	}

	async save_field()
	{

		let post_url = '/admin/save_field';

		// remove empty ones
		for (let i = 0; i < this.allowed_values().length; i++)
		{
			if (ko.mapping.toJS(this.allowed_values()[i]) == '')
				this.allowed_values.remove(this.allowed_values()[i]);
		}

		if (this.default_value() == '' || this.default_value() == undefined)
			this.default_value('Unknown');

		switch (this.field_type())
		{
			case 'YesNo': {
				// clean up array first
				for (let i = 0; i < this.allowed_values().length; i++)
				{
					this.allowed_values.remove(this.allowed_values()[i]);
				}

				this.allowed_values.push(ko.observable(this.default_value()));
				this.allowed_values.push(ko.observable('Yes'));
				this.allowed_values.push(ko.observable('No'));
				break;
			}
			case 'List': {
				// just use list but push default to 1st pos
				this.allowed_values.splice(0, 0, ko.observable(this.default_value()));
				break;
			}
			case 'Text': {
				// clean up array first
				for (let i = 0; i < this.allowed_values().length; i++)
				{
					this.allowed_values.remove(this.allowed_values()[i]);
				}

				break;
			}
			default: break;
		}

		let sub_id = await this.dialog.get_subcat_id_by_cat_id(this.category());

		let obj = {
			description: this.description(),
			default_value: this.default_value(),
			allowed_values: ko.mapping.toJS(this.allowed_values),
			type: this.field_type(),
			category_id: this.category(),
			employee_field_sub_category_id: sub_id,
			access_roles: this.selectedRoles(),
			expire: this.isExpired(),
			department_id: this.department() === 'All' ? null : this.department()
		}
		
		//Validation
		let valid = true;
		let message = '';

		if (!obj['description'])
		{
			valid = false;
			message = tr('Please enter a field name');
		}
		else if (obj['access_roles'].length == 0)
		{
			valid = false;
			message = tr('Please select roles (visible to)');
		}

		let sub_category_name = await this.dialog.get_subcat_name_by_id(this.category());
		if (sub_category_name == 'Educational')
		{
			let response = await Grape.alerts.confirm({
				message: tr('Please note that all educational fields will require the Skills and Competency feature role to be displayed. Are you sure you want to continue'), 
				type: 'warning', title: tr('Warning')});
				
			if (response)
			{
				if (valid == true)
				{
					let res = await Grape.fetches.postJSON(post_url, obj);
					if (res.status == 'OK')
					{
						Grape.alerts.alert({ type: 'success', message: tr('Successfully added field'), title: tr('Success')});
						this.dialog.close();
					}
					else if (res.status == 'ERROR')
						Grape.alerts.alert({type: 'error', message: tr('Something went wrong... Employee field already exists, please try again with a different employee field.'), title: tr('Error')});
				}
				else 
					Grape.alerts.alert({ type: 'error', message: message, title: tr('Error') });
			}
			else
				return;
		}
		else
		{
			if (valid == true)
			{
				let res = await Grape.fetches.postJSON(post_url, obj);
				if (res.status == 'OK')
				{
					Grape.alerts.alert({type: 'success', message: tr('Successfully added field'), title: tr('Success')});
					this.dialog.close();
				}
				else if (res.status == 'ERROR')
				
					Grape.alerts.alert({type: 'error', message: tr('Something went wrong... Employee field entered already exists, please try again with a different employee field name.'), title: tr('Error')});
			}
			else
				Grape.alerts.alert({ type: 'error', message: message, title: tr('Error') });
		}
	};

	add_list_values ()
	{
		this.allowed_values.push(ko.observable(''));
	}

	remove_value(value, index)
		{
			if (this.allowed_values().length > 1) 
				this.allowed_values.splice(index, 1);
			else
				this.allowed_values()[0]('');
		};
	
};

class EmployeeCreateFieldPage
{
	constructor (bindings)
	{
		this.viewModel = new EmployeeCreateFieldViewModel(this);
		this.bindings = bindings;
	};

	async init()
	{
		let res = await Grape.fetches.postJSON('/employee/get_employee_field_categories', {});
		if (res)
		{
			let categoriesWithDisplayText = res.map((category) => {
				return {
					employee_field_category_id: category.employee_field_category_id,
					employee_field_sub_category_id: category.employee_field_sub_category_id, // Replace with the actual property name
					category: category.category,
					employee_field_sub_category_name: category.employee_field_sub_category_name,
					displayText: ko.computed(() => {
						return category.employee_field_sub_category_name + ': ' + category.category;
					})
				};
			});

			this.viewModel.employee_field_categories(categoriesWithDisplayText)
		}

		let res_sub = await Grape.fetches.getJSON('/api/record', { table: 'employee_field_sub_category', limit: 1000000 });
		if (res_sub.records !== null)
			this.viewModel.employee_field_main_categories(res_sub.records);

		let options = {
			table: 'access_role',
			schema: 'grape',
			limit: 1000000,
			sortfield: 'role_name',
			sortorder: 'asc',
			filter: [{
				value: ['guest', 'admin', 'manager', 'employee', 'accountant', 'general_manager', 'developer'],
				op: 'IN',
				field: 'role_name'
			}]
		};

		let res_role = await Grape.fetches.getJSON('/api/record', options);
		if (res_role)
			this.viewModel.access_roles(res_role.records);

		try {
			let options = {
				table: 'department',
				schema: 'public',
				limit: 100000
			}
			let res = await Grape.fetches.getJSON('/api/record', options);
			if (res.status != 'ERROR')
			{
				res.records.unshift({ department: 'All', department_id: null });
				this.viewModel.departments(res.records);
			}
		} catch(error) {
			Grape.alerts.alert({type: 'error', title: 'Error', message: 'Could not load departments'});
			console.error(error);
		}
	};

	

	async get_subcat_id_by_cat_id(employee_field_category_id)
	{
		let category = ko.utils.arrayFirst(this.viewModel.employee_field_categories(), function(item) {
			return item.employee_field_category_id === employee_field_category_id;
		});

		if (category)
			return category.employee_field_sub_category_id;

		return null; // Return null if no matching category is found
	};

	async get_subcat_name_by_id(employee_field_category_id)
	{
		let category = ko.utils.arrayFirst(this.viewModel.employee_field_categories(), (item) => {
			return item.employee_field_category_id === employee_field_category_id;
		});

		if (category)
			return category.employee_field_sub_category_name;
		
		return null; // Return null if no matching category is found
	};
	
};

export default {
	name: 'EmployeeAddField',
	dialog_class: EmployeeCreateFieldPage,
	template: template,
	template_filename: 'translation/dialogs/employee_add_field',
	provider: 'ps'
};
